import { environment } from './../../environments/environment';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// MODULOS
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
// COMPONENTES
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { PoliticaPrivacidadComponent } from './politica-privacidad/politica-privacidad.component';
import { TerminosCondicionesComponent } from './terminos-condiciones/terminos-condiciones.component';





@NgModule({
  declarations: [
    SignUpComponent,
    SignInComponent,
    VerifyEmailComponent,
    RecoverPasswordComponent,
    PoliticaPrivacidadComponent,
    TerminosCondicionesComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule
  ]
})
export class LoginModule { }
